import  gsap  from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


export default class Scroll {
    constructor() {
        this.init();
    }

    init() {
        this.hideText();
    }

    hideText() {
        const triggerElm = document.querySelector('.js-scroll-mv');

        ScrollTrigger.create({
            trigger: triggerElm,
            start: 'top top',
            end: 'bottom top',

            onLeave: () => {
                document.body.classList.add('-mvoff');
            },
            onEnterBack: () => {
                document.body.classList.remove('-mvoff');
            },
            once: false,
            //markers: true,
        });
    }
}
